


<div class="main-page-content">
  <div class="main-page-content-block-secondary mb-3"
       [class.itsfine]="lastStatusCode==3">
    <div class="float-end mt-2 me-2">
      <div class="me-2 d-inline-block" *ngIf="loading">Loading...</div>
      <button class="btn btn-secondary" type="button" (click)="DoReload()">
        <i class="pi pi-refresh" [class.pi-spin]="loading"></i>
      </button>
    </div>
    <h1 class="content-heading-font ms-2">
      System Status
      <span class="font-weight-bold text-danger" *ngIf="lastStatusCode==3">(Critical)</span>
      <span class="font-weight-bold text-warning" *ngIf="lastStatusCode==2">(Warning)</span>
      <span class="font-weight-bold text-success" *ngIf="lastStatusCode==1">(Normal)</span>
    </h1>
    <div class="ms-2">
      <h2 class="text-danger mb-2 " style=" white-space: pre;">{{failedMessage  }}</h2>
      <h3 class="text-warning mb-2 " style=" white-space: pre;">{{warningMessage }}</h3>
      <span style="text-shadow: none;">{{lastStatusDate  }}</span>
      
    </div>

  </div>

  <div class="main-page-content-block mb-3" id="divWebSites">
    <h1 class="content-heading-font ms-2">Web Sites</h1>

    <div class="row">
      <div class="col-12 col-md mb-3" *ngFor="let webSiteStatus of webSiteStatuses; let i = index">
        <div class="card text-bg-{{GetStatusColor(webSiteStatus)}}">
          <div class="card-header fs-4 text-truncate" style="min-width: 400px;">
            <div class="float-end ">
              <button class="btn btn-sm card-header-btn " type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#WebSite' + webSiteStatus.SiteId">
                <i class="fa fa-angle-double-down "></i>
              </button>
            </div>
            {{webSiteStatus.SiteName}}
          </div>
          <div class="card-body">
            <h5 class="card-title font-weight-bold">{{GetStatusText(webSiteStatus)}}</h5>
            <p class="card-text">

              <span>Requests </span>: <span class="font-weight-bold">{{webSiteStatus.RequestsExecuting_App}} ({{webSiteStatus.RequestExecutingTime_App}}ms) / {{webSiteStatus.RequestsInQueue_App}} ({{webSiteStatus.RequestWaitTime_App}}ms) </span><br />
              <span>Process</span>:
              <span class="font-weight-bold">{{webSiteStatus.ProcessIDs}}</span>
              <span class="font-weight-bold">({{webSiteStatus.PercentProcessorTime}}% / {{formatByteSizeMB(webSiteStatus.WorkingMemoryMB )}} )</span>

              <span class="font-weight-bold text-info" *ngIf="webSiteStatus.IsIdle">(Idle)</span>
              <br />

              <span>Run Time</span>: <span class="font-weight-bold"> {{getRuntime(webSiteStatus.StartTime )}} since {{webSiteStatus.StartTime | date:'medium' }}</span><br />


            </p>
            <div class="collapse " id="WebSite{{webSiteStatus.SiteId}}">
              <div *ngIf="webSiteStatus.DomainNames">
                <span>Domain Names</span>: <span class="font-weight-bold">{{webSiteStatus.DomainNames}}</span><br />
              </div>
              <div *ngIf="webSiteStatus.ApplicationPool">
                <span>Application Pool</span>: <span class="font-weight-bold">{{webSiteStatus.ApplicationPool}}</span><br />
              </div>
              <div *ngIf="webSiteStatus.AppDomain">
                <span>App Domain</span>: <span class="font-weight-bold">{{webSiteStatus.AppDomain}}</span><br />
              </div>
              <div *ngIf="webSiteStatus.MachineName">
                <span>Machine Name</span>: <span class="font-weight-bold">{{webSiteStatus.MachineName}}</span><br />
              </div>
              <div *ngIf="webSiteStatus.Version">
                <span>Version</span>: <span class="font-weight-bold">{{webSiteStatus.Version}}</span><br />
              </div>
              <div *ngIf="webSiteStatus.BuildDate">
                <span>Build Date</span>: <span class="font-weight-bold">{{webSiteStatus.BuildDate | date:'medium' }}</span><br />
              </div>
              <div *ngIf="webSiteStatus.PhysicalPath">
                <span>Physical Path</span>: <span class="font-weight-bold">{{webSiteStatus.PhysicalPath}}</span><br />
              </div>
              <div *ngIf="webSiteStatus.FileName">
                <span>File Name</span>: <span class="font-weight-bold">{{webSiteStatus.FileName}}</span><br />
              </div>

              <div>
                <span>Requests per Min </span>: <span class="font-weight-bold">{{webSiteStatus.RequestsMin_App || webSiteStatus.RequestsMin_Http}}</span><br />
              </div>
              <div>
                <span>Requests In Queue</span>: <span class="font-weight-bold">{{webSiteStatus.RequestsInQueue_App || webSiteStatus.RequestsInQueue_Http}} ({{webSiteStatus.RequestWaitTime_App}}ms)</span><br />
              </div>
              <div>
                <span>Requests Executing</span>: <span class="font-weight-bold">{{webSiteStatus.RequestsExecuting_App}}  ({{webSiteStatus.RequestExecutingTime_App}}ms) </span><br />
              </div>
              <div>
                <span>Current Connections</span>: <span class="font-weight-bold">{{webSiteStatus.CurrentConnections_Http}} </span><br />
              </div>

              <div>
                <span>Bytes</span>: <span class="font-weight-bold">{{webSiteStatus.BytesReceivedSec}} / {{webSiteStatus.BytesSentSec}}</span><br />
              </div>

              <div>
                <span>Status Updated</span>: <span class="font-weight-bold">{{getRuntime(webSiteStatus.Date )}} at {{webSiteStatus.Date | date:'medium' }}</span><br />
              </div>
              

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="main-page-content-block mb-3" id="divServices">
    <h1 class="content-heading-font ms-2">Services</h1>

    <div class="row">
      <div class="col-12 col-md mb-3" *ngFor="let serviceStatus of serviceStatuses; let i = index">
        <div class="card text-bg-{{GetStatusColor(serviceStatus)}}">
          <div class="card-header fs-4">
            <div class="float-end ">
              <button class="btn btn-sm card-header-btn " type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#Service' + serviceStatus.ID">
                <i class="fa fa-angle-double-down "></i>
              </button>
            </div>
            {{serviceStatus.ServiceName}}
          </div>
          <div class="card-body">
            <h5 class="card-title font-weight-bold">{{GetStatusText(serviceStatus)}}</h5>
            <p class="card-text">
              <span>CPU</span>: <span class="font-weight-bold">{{serviceStatus.PercentProcessorTime}}% - Process #{{serviceStatus.ProcessID}}</span><br />
              <span>Memory</span>: <span class="font-weight-bold"> {{formatByteSizeMB(serviceStatus.WorkingMemoryMB )}}</span><br />
              <span>Run Time</span>: <span class="font-weight-bold"> {{getRuntime(serviceStatus.StartTime )}} since {{serviceStatus.StartTime | date:'medium' }}</span><br />

            </p>
            <div class="collapse " id="Service{{serviceStatus.ID}}">
              <div *ngIf="serviceStatus.MachineName">
                <span>MachineName</span>: <span class="font-weight-bold">{{serviceStatus.MachineName}}</span><br />
              </div>
              <div *ngIf="serviceStatus.Environment">
                <span>Environment</span>: <span class="font-weight-bold">{{serviceStatus.Environment}}</span><br />
              </div>
              <div *ngIf="serviceStatus.BuildDate">
                <span>BuildDate</span>: <span class="font-weight-bold">{{serviceStatus.BuildDate | date:'medium' }}</span><br />
              </div>
              <div *ngIf="serviceStatus.Version">
                <span>Version</span>: <span class="font-weight-bold">{{serviceStatus.Version}}</span><br />
              </div>
              <div *ngIf="serviceStatus.FileName">
                <span>FileName</span>: <span class="font-weight-bold">{{serviceStatus.FileName}}</span><br />
              </div>
              <div>
                <span>Status Updated</span>: <span class="font-weight-bold">{{getRuntime(serviceStatus.Date )}} at {{serviceStatus.Date | date:'medium' }}</span><br />
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="main-page-content-block mb-3" id="divServers">
    <h1 class="content-heading-font ms-2">Servers</h1>

    <div class="row">
      <div class="col-12 col-md mb-3" *ngFor="let serverStatus of serverStatuses; let i = index">
        <div class="card text-bg-{{GetStatusColor(serverStatus)}}">
          <div class="card-header fs-4">
            <div class="float-end ">
              <button class="btn btn-sm card-header-btn " type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#Server' + serverStatus.ID">
                <i class="fa fa-angle-double-down "></i>
              </button>
            </div>
            {{serverStatus.MachineName}}
          </div>
          <div class="card-body">
            <h5 class="card-title font-weight-bold">{{GetStatusText(serverStatus)}}</h5>
            <p class="card-text">
              <span>CPU</span>: <span class="font-weight-bold">{{serverStatus.ServerPercentProcessorTime}}% - {{serverStatus.NumberOfProcesses}} Processes - {{serverStatus.OperationalStatus}}</span><br />
              <span>Free Physical Memory</span>: <span class="font-weight-bold"> {{formatPercentage(serverStatus.FreePhysicalMemoryMB, serverStatus.TotalVisibleMemorySizeMB)}} - {{formatByteSizeMB(serverStatus.FreePhysicalMemoryMB )}} of {{formatByteSizeMB(serverStatus.TotalVisibleMemorySizeMB)}}</span><br />
              <span>Run Time</span>: <span class="font-weight-bold"> {{getRuntime(serverStatus.LastBootUpTime )}} since {{serverStatus.LastBootUpTime | date:'medium' }}</span><br />


            </p>
            <div class="collapse " id="Server{{serverStatus.ID}}">
              <div *ngIf="serverStatus.LoggedUsers">
                <span>Users</span>: <span class="font-weight-bold">{{serverStatus.LoggedUsers}} ({{serverStatus.NumberOfUsers}})</span><br />
              </div>
              <div *ngIf="serverStatus.ServerModel">
                <span>Model</span>: <span class="font-weight-bold">{{serverStatus.ServerModel}}</span><br />
              </div>
              <div *ngIf="serverStatus.OperatingSystem">
                <span>OS</span>: <span class="font-weight-bold">{{serverStatus.OperatingSystem}}</span><br />
              </div>
              <span>Free Virtual Memory</span>: <span class="font-weight-bold"> {{formatPercentage(serverStatus.FreeVirtualMemoryMB, serverStatus.TotalVirtualMemorySizeMB)}} - {{formatByteSizeMB(serverStatus.FreeVirtualMemoryMB )}} of {{formatByteSizeMB(serverStatus.TotalVirtualMemorySizeMB)}}</span><br />
              <div *ngIf="serverStatus.PublicIP">
                <span>Public IP</span>: <span class="font-weight-bold">{{serverStatus.PublicIP}}</span> (<span class="font-weight-bold">{{serverStatus.PrivateIP}}</span> )<br />
              </div>

              <div *ngIf="serverStatus.DriveC_TotalSizeMB">
                <span>C: Disk Space</span>: <span class="font-weight-bold">{{formatPercentage(serverStatus.DriveC_AvailableFreeSpaceMB, serverStatus.DriveC_TotalSizeMB)}} - {{formatByteSizeMB(serverStatus.DriveC_AvailableFreeSpaceMB)}} of {{formatByteSizeMB(serverStatus.DriveC_TotalSizeMB)}}</span>
              </div>
              <div *ngIf="serverStatus.DriveD_TotalSizeMB">
                <span>D: Disk Space</span>: <span class="font-weight-bold">{{formatPercentage(serverStatus.DriveD_AvailableFreeSpaceMB, serverStatus.DriveD_TotalSizeMB)}} - {{formatByteSizeMB(serverStatus.DriveD_AvailableFreeSpaceMB)}} of {{formatByteSizeMB(serverStatus.DriveD_TotalSizeMB)}}</span>
              </div>
              <div *ngIf="serverStatus.DriveX_TotalSizeMB">
                <span>X: Disk Space</span>: <span class="font-weight-bold">{{formatPercentage(serverStatus.DriveX_AvailableFreeSpaceMB, serverStatus.DriveX_TotalSizeMB)}} - {{formatByteSizeMB(serverStatus.DriveX_AvailableFreeSpaceMB)}} of {{formatByteSizeMB(serverStatus.DriveX_TotalSizeMB)}}</span>
              </div>
              <div>
                <span>Status Updated</span>: <span class="font-weight-bold">{{getRuntime(serverStatus.Date )}} at {{serverStatus.Date | date:'medium' }}</span><br />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>



  <div class="main-page-content-block mb-3" id="divWebUrls">
    <h1 class="content-heading-font ms-2">Monitored Web URLs</h1>

    <div class="row">
      <div class="col-12 col-md mb-3" *ngFor="let webUrl of webUrls; let i = index">
        <div class="card text-bg-{{GetStatusColor(webUrl)}}">
          <div class="card-header fs-4 text-truncate" style="min-width: 400px;">
            <div class="float-end ">
              <button class="btn btn-sm card-header-btn " type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#WebSite' + webUrl.ID">
                <i class="fa fa-angle-double-down "></i>
              </button>
            </div>
            {{webUrl.UrlName}}
          </div>
          <div class="card-body">
            <h5 class="card-title font-weight-bold ">{{GetStatusText(webUrl)}}</h5>
            <p class="card-text">
              <span>Response Time Taken</span>: <span class="font-weight-bold">{{webUrl.ResponseTimeTaken}}ms</span><br />
              <span>HTTP Status Code</span>: <span class="font-weight-bold"> {{webUrl.ResponseHttpStatusCode }}</span><br />
              <span>Response Date</span>: <span class="font-weight-bold"> {{getRuntime(webUrl.ResponseDate )}} since {{webUrl.ResponseDate | date:'medium' }}</span><br />


            </p>
            <div class="collapse " id="WebSite{{webUrl.ID}}">
              <div *ngIf="webUrl.ResponseText">
                <span class="font-weight-bold">{{webUrl.ResponseText}}</span><br />
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

</div>

